import Link from "next/link";
import Image from 'next/image';
import React, { useEffect } from "react";

const FeaturedPosts = ({featuredPosts}:any) => {
  return (
    <div className="d-none d-sm-block col-sm-3 featured-blog-post-col">
      <h2>Featured Posts</h2>
      <hr />
      <ul className="featured-blog-post-list">
      {featuredPosts.map((fPost:any) => (
        <li key={fPost._id} className="featured-blog-post-item"><a href={`/post/${fPost.url_path}`}>{fPost.title}</a></li>
      ))}
      </ul>
    </div>
  )
}

export default FeaturedPosts;
